import { render } from "./Index.vue?vue&type=template&id=cc965b7c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=cc965b7c&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=cc965b7c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc965b7c"]])

export default __exports__